import { ContentCard } from "@msuite/ui/content-card";
import { FileUpload } from "@msuite/ui/file-upload";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useRef } from "react";
import { FileCardRemote } from "@/components/files";
import { useCalculationEditorContext } from "@/sites/calculations/calculation-editor/context";

export function CalculationFormFiles() {
	/** Hooks */
	const { fileUploadController } = useCalculationEditorContext();
	const ref = useRef<HTMLDivElement>(null);

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div
			className="h-full"
			ref={ref}
		>
			<ContentCard
				variant="plain"
				title={t("files.files")}
				icon={icon("File")}
				className="min-h-0 flex-grow-0"
				style={{ height: ref.current?.clientHeight }}
				contentClassName="grid grid-rows-[1fr_max-content] h-full flex-grow-0 overflow-hidden gap-0"
			>
				<div className="flex-1 overflow-y-auto min-h-0 max-h-full">
					<FileUpload
						withLabel={false}
						controller={fileUploadController}
						renderFile={(file) => (
							<FileCardRemote
								fileId={file.id}
								onInteraction={async () => {
									// refetch?.();
								}}
							/>
						)}
					/>
				</div>
			</ContentCard>
		</div>
	);
}
